'use client';

import { usePathname } from 'next/navigation';

import type { LandingNav, LandingTheme, NavTabsConfig } from '../../_lib/schema/landing-config.schema';
import { LanguageToggleButton } from '../language-toggle-button';
import { SiteHeaderAccountSection } from '../site-header-account-section';
import { SiteAuthenticatedNavigation } from '../site-navigation';
import { SportsSiteHeader } from './sports-site-chrome';

export function isWebsiteBuilderPath(pathname: string) {
  return pathname === '/' || pathname.startsWith('/pages/');
}

export function SportsTenantHeader({ nav, logoUrl, businessName, navTabs, accent, accentForeground, fontFamily, buttonShape }: {
  nav: LandingNav;
  logoUrl?: string | null;
  businessName?: string | null;
  navTabs?: NavTabsConfig;
  accent?: string;
  accentForeground?: string;
  fontFamily?: LandingTheme['fontFamily'];
  buttonShape?: LandingTheme['buttonShape'];
}) {
  const pathname = usePathname();
  // Only Website Builder pages reserve space behind an overlay header; app pages need it solid.
  const headerNav = nav.headerStyle === 'overlay' && !isWebsiteBuilderPath(pathname) ? { ...nav, headerStyle: 'solid' as const } : nav;
  // Therapy headers keep member tabs in the account menu so the bar stays one row.
  const therapy = nav.presentation === 'therapy';

  return <SportsSiteHeader nav={headerNav} logoUrl={logoUrl} businessName={businessName} accent={accent} accentForeground={accentForeground} fontFamily={fontFamily} buttonShape={buttonShape} accountControl={<SiteHeaderAccountSection hideBookingAction={Boolean(nav.primaryAction)} accountMenuTabs={therapy ? navTabs ?? {} : undefined} />} languageControl={<LanguageToggleButton />} memberNavigation={therapy ? null : <SiteAuthenticatedNavigation tabs={navTabs} />} />;
}
